/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const FastingIcon = props => {
	const { color = '' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 50 50'
			style={{
				enableBackground: 'new 0 0 50 50'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			fill={color}
			{...props}
		>
			<path d='M25.2.4C11.5.4.5 11.5.5 25.2S11.5 50 25.2 50 50 38.9 50 25.2C50 11.5 38.9.4 25.2.4zm0 47.3c-12.4 0-22.5-10.1-22.5-22.5S12.8 2.7 25.2 2.7v-.3.2c12.4 0 22.5 10.1 22.5 22.5.1 12.5-10 22.6-22.5 22.6z' />
			<path d='M35.2 8c-.5-.3-1.2-.1-1.5.4L25.3 23h-.1c-.9 0-1.7.5-2 1.2h-9.8c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1h9.8c.4.7 1.2 1.2 2 1.2 1.2-.1 2.2-1.1 2.3-2.3 0-.4-.1-.8-.3-1.2l8.4-14.6c.3-.6.1-1.2-.4-1.5zM25.2 9.8c.6 0 1.1-.5 1.1-1.1V6.3c0-.6-.5-1-1-1-.6 0-1.1.4-1.1 1v2.4c0 .6.5 1 1 1.1zM25.3 40.7c-.6 0-1.1.4-1.1 1v2.4c0 .6.5 1 1.1 1 .6 0 1-.5 1-1.1v-2.4c0-.4-.5-.9-1-.9zM17.4 38.6c-.5-.3-1.2-.1-1.5.4l-1.1 2.1v.1c-.1.2-.1.5-.1.8.1.3.2.5.5.6.1.1.3.1.5.1h.1c.4 0 .7-.2.9-.5l1.1-2.1c.4-.6.2-1.2-.4-1.5zM10.4 32.6l-2 1.1-.1.1c-.5.3-.7.9-.4 1.4.2.3.5.6.9.6h.1c.2 0 .4 0 .5-.1l2.1-1.1c.5-.3.7-.9.4-1.4-.4-.7-1-.9-1.5-.6zM39.5 18.1h.1c.1 0 .1 0 .2-.1H40.1l2.1-1.2c.2-.1.4-.4.5-.6.1-.3 0-.6-.1-.8-.3-.5-.9-.7-1.5-.4l-2 1.1H39c-.5.3-.7.9-.4 1.4.2.4.5.6.9.6zM8.7 26.3c.6 0 1.1-.5 1.1-1.1 0-.6-.5-1-1.1-1.1H6.3c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1h2.4zM11.4 16.1 9.3 15h-.1c-.5-.3-1.2-.1-1.5.4-.3.5-.1 1.2.4 1.5l2.1 1.1c.1.1.3.1.5.1h.1c.4 0 .7-.2.9-.5l.1-.1c.3-.5.1-1.2-.4-1.4zM42.1 33.8 40 32.6c-.5-.3-1.2-.1-1.5.4-.3.5-.1 1.2.4 1.5l2.1 1.1c.2.1.4.2.5.1h.1c.4 0 .7-.2.8-.5.4-.5.2-1.2-.3-1.4zM16 11.4c.1.3.5.6.9.6h.1c.2 0 .3 0 .5-.1l.1-.1c.5-.3.7-.9.4-1.4l-1.1-2.1c-.3-.3-.6-.5-.9-.5-.6-.2-1.2.2-1.3.8-.1.3 0 .6.1.8l1.2 2zM34.5 39c-.1-.2-.4-.4-.7-.5-.3-.1-.6 0-.8.1-.5.3-.7.9-.4 1.5l1.1 2.1c.1.3.5.6.9.6h.1c.2 0 .3 0 .5-.1h.1c.5-.3.7-.9.4-1.5L34.5 39zM44.2 24.1h-2.4c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1h2.4c.6 0 1-.5 1-1.1 0-.6-.5-1-1-1.1z' />
		</svg>
	)
}

export default FastingIcon
